import { clsx } from 'clsx';
import { NavLink } from 'react-router';

interface NavbarLinkProps {
  label: string;
  route: string;
}

export default function NavbarLink({ label, route }: NavbarLinkProps) {
  return (
    <NavLink to={route} className="no-underline">
      {({ isActive }) => (
        <div
          className={clsx('flex p-4 font-mono uppercase hover:opacity-80', {
            'text-white': !isActive,
            'text-secondary': isActive,
          })}
        >
          <div className="pl-4">{label}</div>
        </div>
      )}
    </NavLink>
  );
}
